<template>
    <div id="password">
        <div class="head-tool">
            <span @click="$router.go(-1)"><i class="el-icon-arrow-left"></i> 返回</span>
            <span class="tc">设置密码</span>
            <span class="tr" @click="$router.push('/')">首页</span>
        </div>
        <div class="form">
            <el-input placeholder="请输入密码" v-model="password" show-password></el-input>
            <button @click="resetPass">确定</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Password",
        data(){
            return {
                password : ''
            }
        },
        methods:{
            resetPass(){
                if(this.password.length < 5 && this.password > 16){
                    alert("密码长度应当在5-16位字符之间！")
                    return ;
                }
                this.axios.post('/api/user/resetPass',{
                    password : this.password
                }).then(r => {
                    alert(r.data.msg);
                    this.$router.push('/user')
                })
            }
        }
    }
</script>

<style lang="less">
    #password{overflow: hidden;height: 100%;
        .head-tool{display: flex;padding: 26px 20px;background: #fff;border-bottom: 1px solid #efefef;
            span{flex:1;font-size: 30px;color:#333;
                i{font-size: 30px;}
            }
        }
        .form{
            width:90%;margin:30px auto;
            input{height:80px;}
            button{width: 100%;height: 80px;background: @theme;color:#fff;border:none;border-radius: 4px;margin-top: 30px;font-size: 30px;}
        }
    }
</style>
